import { getAllSales } from '../../api/salesApi'
import EditAdminSalesModal from './editAdminSalesModal';
import GenericSalesList from '../common/genericSalesList';

export default function AdminSalesList() {

    return (
        <GenericSalesList
            fetchDataApi={(archived) => getAllSales(archived)}
            showArchiveToggle
            ModalComponent={EditAdminSalesModal}
            title="All Sales"
            subtitle="View and manage all sales records"
        />
    );
}
